<div class="content-block">

    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h2 class="content-block">Restituzione Giornaliera</h2>

                @if(isBase){
                <div class="button-esci">
                    <dx-button stylingMode="contained" type="default" text="Esci" class="dx-button-orange button-esci"
                        (onClick)="esci()" width="150">
                    </dx-button>
                </div>
                }
            </div>
        </div>
    </div>
    <div class="row g-3 mb-3">
        @if(isMax1600()){
        <div class="col-7 col-lg-4">
            <div class="row ">
                <div class="row schermo-piccolo">
                    <div class="card p-3 div-barcode">
                        <!--<h3 class="card-title font-weight-bold">Nuova consegna</h3>-->
                        <form id="form-nuova-consegna">
                            <dx-validation-group>
                                <div class="row">
                                    <div class="col-5 col-md-4">
                                        <dx-date-box #data displayFormat=" dd/MM/yyyy" [(value)]="dataConsegna"
                                            width="100%">
                                            <dx-validator>
                                                <dxi-validation-rule type="required"
                                                    message="Selezionare la data"></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-date-box>

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="div-dipendente">
                                        <div class="col-5 col-md-4">
                                            <dx-text-box #barcodeDipendente [(value)]="codiceDipendente"
                                                placeholder="Barcode Dipendente" valueChangeEvent="keyup"
                                                (onEnterKey)="onCodiceDipendenteChanged()"
                                                (onContentReady)="onBarcodeDipendenteTxtBoxInitialized($event)"
                                                [(disabled)]="dipendenteInserito">

                                            </dx-text-box>
                                        </div>
                                        <div class="col-5 col-md-5">
                                            <dx-text-box [(value)]="dipendente" [disabled]="true"
                                                class="disabled-txt"></dx-text-box>
                                        </div>
                                        @if(buttonDipendente){
                                        <dx-button stylingMode="contained" text="Cerca" icon="search" type="normal"
                                            (onClick)="onDipendenteCerca()" class="button-cerca">
                                        </dx-button>
                                        }
                                    </div>
                                </div>
                                @if(sezioneArticolo){
                                <div class="row">
                                    <div class="barcode-articolo">
                                        <div class="col-5 col-md-4">
                                            <dx-text-box #barcodeArticolo [(value)]="codiceArticolo"
                                                placeholder="Barcode Articolo" valueChangeEvent="keyup"
                                                (onEnterKey)="onBarcodeArticolo()"
                                                (onContentReady)="onBarcodeArticoloTxtBoxInitialized($event)">

                                            </dx-text-box>
                                        </div>
                                    </div>
                                </div>
                                }
                            </dx-validation-group>
                        </form>
                    </div>
                </div>
                <div class="row schermo-piccolo">
                    <div class="card p-3 div-barcode">
                        @if(rigaSelezionata != undefined && qtaRestituitaInsufficiente()){
                        <div class="matricole-div">
                            <div class="col-12 header-matricola">

                                <i class="dx-icon-warning warning-icon"></i>
                                <h4>Quantità mancante per articolo</h4>
                                <p>getDescrizione()</p>
                            </div>
                        </div>
                        }
                        @if(rigaSelezionata != undefined && !qtaRestituitaInsufficiente()){
                        <div class="matricole-div">
                            <div class="col-12 header-matricola">

                                <i class="dx-icon-check check-icon"></i>
                                <h4>Quantità articolo consegnata</h4>
                                <p>getDescrizione()</p>
                            </div>
                        </div>
                        }

                    </div>
                </div>
            </div>

        </div>
        <div class="col-12 col-lg-8">
            <div class="card p-3">
                <div class="row ">
                    <h4>Articoli Restituiti:</h4>
                </div>
                <dx-data-grid #gridDettaglioMov [dataSource]="listArticoli" keyExpr="dataInserimento"
                    [showBorders]="true" [focusedRowEnabled]="true" [focusedRowIndex]="0" [columnAutoWidth]="true"
                    [columnHidingEnabled]="false" (onFocusedRowChanged)="onFocusedRowChanged($event)"
                    (onEditorPreparing)="onEditorPreparing($event)" (onRowUpdated)="rowUpdated($event)"
                    (onSelectionChanged)="onSelectionChanged($event)" (onRowPrepared)="onRowPrepared($event)"
                    [editing]="{mode: 'cell'}" [showRowLines]="true" [showColumnLines]="true">
                    <!-- (onRowInserted)="onRowInserted($event)" -->

                    <dxo-editing mode="row" [allowAdding]="false" [allowUpdating]="true" [allowDeleting]="false"
                        [useIcons]="true">
                    </dxo-editing>


                    <dxo-selection mode="single"></dxo-selection>

                    <dxi-column cellTemplate="validoTemplate" width="50" alignment="center" [allowSorting]="false"
                        [allowEditing]="false"></dxi-column>

                    <div *dxTemplate="let d of 'validoTemplate'">
                        @if(d.data.quantitaRestituita < d.data.quantita){ <i class="dx-icon-clearcircle color-red"></i>
                            }
                            @else{
                            <i class="dx-icon-check color-blue"></i>
                            }
                    </div>

                    <dxi-column dataField="quantita" caption="Qtà" dataType="number" width="80" alignment="center"
                        [allowSorting]="false" [allowEditing]="false">
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dxi-column>

                    <dxi-column dataField="quantitaRestituita" caption="Qtà Rest" dataType="number" width="80"
                        alignment="center" [cellTemplate]="'viewQta'" [editCellTemplate]="'editQta'"
                        [allowSorting]="false">
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dxi-column>

                    <div *dxTemplate="let d of 'viewQta'">
                        {{d.value}}
                    </div>

                    <div *dxTemplate="let d of 'editQta'">
                        <dx-number-box [value]="d.value" [showSpinButtons]="true" [min]="0" [step]="1"
                            [readOnly]="d.data.usaMatricola" (onValueChanged)="onQtaChanged($event, d.data)"
                            [max]="d.data.quantita">
                        </dx-number-box>
                    </div>

                    <dxi-column cellTemplate="kitTemplate" caption="Kit" width="80" alignment="center"
                        [allowSorting]="false" [allowEditing]="false"></dxi-column>

                    <div *dxTemplate="let d of 'kitTemplate'">
                        @if(d.data.gestioneKit){
                        <i class="dx-icon-check color-blue"></i>
                        }
                        @if(d.data.componenteFiglio){
                        <i class="dx-icon-hierarchy color-blue"></i>
                        }
                    </div>


                    <dxi-column dataField="idArticolo" caption="Articolo" cellTemplate="descrizioneArticolo"
                        [allowSorting]="false" alignment="left" [allowEditing]="false">

                    </dxi-column>
                    <div *dxTemplate="let d of 'descrizioneArticolo'">
                        {{getArticoloDisplay(d.data)}}
                    </div>



                </dx-data-grid>
                <div class="row single-button">
                    <dx-button stylingMode="contained" type="default" text="Annulla" class="dx-button-orange"
                        (onClick)="ripulisciDati()" width="150">
                    </dx-button>
                    <dx-button stylingMode="contained" type="default" text="Restituisci" class="dx-button-orange"
                        (onClick)="effettuaResituzione($event)" width="150">
                    </dx-button>
                </div>
            </div>
        </div>
        }
        @else{
        <div class="col-7 col-lg-4">
            <div class="card p-3 div-barcode">
                <!--<h3 class="card-title font-weight-bold">Nuova consegna</h3>-->
                <form id="form-nuova-consegna">
                    <dx-validation-group>
                        <div class="row">
                            <div class="col-5 col-md-4">
                                <dx-date-box #data displayFormat=" dd/MM/yyyy" [(value)]="dataConsegna" width="100%">
                                    <dx-validator>
                                        <dxi-validation-rule type="required"
                                            message="Selezionare la data"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-date-box>

                            </div>
                        </div>
                        <div class="row">
                            <div class="div-dipendente">
                                <div class="col-5 col-md-4">
                                    <dx-text-box #barcodeDipendente [(value)]="codiceDipendente"
                                        placeholder="Barcode Dipendente" valueChangeEvent="keyup"
                                        (onEnterKey)="onCodiceDipendenteChanged()"
                                        (onContentReady)="onBarcodeDipendenteTxtBoxInitialized($event)"
                                        [(disabled)]="dipendenteInserito">

                                    </dx-text-box>
                                </div>
                                <div class="col-5 col-md-5">
                                    <dx-text-box [(value)]="dipendente" [disabled]="true"
                                        class="disabled-txt"></dx-text-box>
                                </div>
                                @if(buttonDipendente){
                                <dx-button stylingMode="contained" text="Cerca" icon="search" type="normal"
                                    (onClick)="onDipendenteCerca()" class="button-cerca">
                                </dx-button>
                                }
                            </div>
                        </div>
                        @if(sezioneArticolo){
                        <div class="row">
                            <div class="barcode-articolo">
                                <div class="col-5 col-md-4">
                                    <dx-text-box #barcodeArticolo [(value)]="codiceArticolo"
                                        placeholder="Barcode Articolo" valueChangeEvent="keyup"
                                        (onEnterKey)="onBarcodeArticolo()"
                                        (onContentReady)="onBarcodeArticoloTxtBoxInitialized($event)">

                                    </dx-text-box>
                                </div>
                            </div>
                        </div>
                        }
                    </dx-validation-group>
                </form>
            </div>
        </div>
        <div class="col-5 col-lg-2 div-barcode">
            <div class="card p-3 div-barcode">
                <!--<h3 class="card-title font-weight-bold">Nuova consegna</h3>-->
                @if(sceltaMatricola){
                <div class="row matricole-div">
                    <div class="col-12 header-matricola">

                        <i class="dx-icon-warning warning-icon"></i>
                        <h4>Inserire la matricola dell'articolo</h4>

                    </div>

                    <dx-text-box #barcodeMatricola class="col-9" [(value)]="matricolaArticolo"
                        placeholder="Matricola Articolo" valueChangeEvent="keyup" (onEnterKey)="onMatricolaArticolo()">
                    </dx-text-box>

                    <dx-button stylingMode="contained" text="Cerca" icon="search" type="normal"
                        (onClick)="onMatricolaCerca()" class="button-cerca">
                    </dx-button>
                </div>
                }
                @if(rigaSelezionata != undefined && qtaRestituitaInsufficiente() && !sceltaMatricola){
                <div class="matricole-div">
                    <div class="col-12 header-matricola">

                        <i class="dx-icon-warning warning-icon"></i>
                        <h4>Quantità mancante per articolo</h4>
                        <p>{{getDescrizione()}}</p>
                    </div>
                </div>
                }
                @if(rigaSelezionata != undefined && !qtaRestituitaInsufficiente() && !sceltaMatricola){
                <div class="matricole-div">
                    <div class="col-12 header-matricola">

                        <i class="dx-icon-check check-icon"></i>
                        <h4>Quantità articolo consegnata</h4>
                        <p>{{getDescrizione()}}</p>
                    </div>
                </div>
                }
            </div>
        </div>
        <div class="col-12 col-lg-6">
            <div class="card p-3">
                <div class="row ">
                    <h4>Articoli Restituiti:</h4>
                </div>
                <dx-data-grid #gridDettaglioMov [dataSource]="listArticoli" keyExpr="dataInserimento"
                    [showBorders]="true" [focusedRowEnabled]="true" [focusedRowIndex]="0" [columnAutoWidth]="true"
                    [columnHidingEnabled]="false" (onFocusedRowChanged)="onFocusedRowChanged($event)"
                    (onEditorPreparing)="onEditorPreparing($event)" (onRowUpdated)="rowUpdated($event)"
                    (onSelectionChanged)="onSelectionChanged($event)" (onRowPrepared)="onRowPrepared($event)"
                    [editing]="{mode: 'cell'}" [showRowLines]="true" [showColumnLines]="true">
                    <!-- (onRowInserted)="onRowInserted($event)" -->

                    <dxo-editing mode="row" [allowAdding]="false" [allowUpdating]="true" [allowDeleting]="false"
                        [useIcons]="true">
                    </dxo-editing>


                    <dxo-selection mode="single"></dxo-selection>

                    <dxi-column cellTemplate="validoTemplate" width="50" alignment="center" [allowSorting]="false"
                        [allowEditing]="false"></dxi-column>

                    <div *dxTemplate="let d of 'validoTemplate'">
                        @if(d.data.quantitaRestituita < d.data.quantita){ <i class="dx-icon-clearcircle color-red"></i>
                            }
                            @else{
                            <i class="dx-icon-check color-blue"></i>
                            }
                    </div>

                    <dxi-column dataField="quantita" caption="Qtà" dataType="number" width="80" alignment="center"
                        [allowSorting]="false" [allowEditing]="false">
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dxi-column>

                    <dxi-column dataField="quantitaRestituita" caption="Qtà Rest" dataType="number" width="80"
                        alignment="center" [cellTemplate]="'viewQta'" [editCellTemplate]="'editQta'"
                        [allowSorting]="false">
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dxi-column>

                    <div *dxTemplate="let d of 'viewQta'">
                        {{d.value}}
                    </div>

                    <div *dxTemplate="let d of 'editQta'">
                        <dx-number-box [value]="d.value" [showSpinButtons]="true" [min]="0" [step]="1"
                            [readOnly]="d.data.usaMatricola" (onValueChanged)="onQtaChanged($event, d.data)"
                            [max]="d.data.quantita">
                        </dx-number-box>
                    </div>

                    <dxi-column cellTemplate="kitTemplate" caption="Kit" width="80" alignment="center"
                        [allowSorting]="false" [allowEditing]="false"></dxi-column>

                    <div *dxTemplate="let d of 'kitTemplate'">
                        @if(d.data.gestioneKit){
                        <i class="dx-icon-check color-blue"></i>
                        }
                        @if(d.data.componenteFiglio){
                        <i class="dx-icon-hierarchy color-blue"></i>
                        }
                    </div>


                    <dxi-column dataField="idArticolo" caption="Articolo" cellTemplate="descrizioneArticolo"
                        [allowSorting]="false" alignment="left" [allowEditing]="false">

                    </dxi-column>
                    <div *dxTemplate="let d of 'descrizioneArticolo'">
                        {{getArticoloDisplay(d.data)}}
                    </div>



                </dx-data-grid>
                <div class="row single-button">
                    <dx-button stylingMode="contained" type="default" text="Annulla" class="dx-button-orange"
                        (onClick)="ripulisciDati()" width="150">
                    </dx-button>
                    <dx-button stylingMode="contained" type="default" text="Restituisci" class="dx-button-orange"
                        (onClick)="effettuaResituzione($event)" width="150">
                    </dx-button>
                </div>
            </div>

        </div>
        }
    </div>
</div>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="visibleLoadPanel" [showIndicator]="true"
    [showPane]="true" [shading]="true" [hideOnOutsideClick]="false" message="Recupero restituzioni previste">
</dx-load-panel>

@if(popupSceltaDipendente){
<dx-popup [width]="600" [height]="250" [showTitle]="true" title="" [dragEnabled]="false" [hideOnOutsideClick]="true"
    [(visible)]="popupSceltaDipendente">
    <app-popup-scelta-dipendente [listDipendenti]="listDipendenti"
        (idDipendenteEventEmitter)="onIdDipendenteEventEmitter($event)"></app-popup-scelta-dipendente>
</dx-popup>
}
@if (popupNota) {
<dx-popup [width]="550" [height]="altezzaPopupNota" [showTitle]="true" [dragEnabled]="false" [hideOnOutsideClick]="true"
    [showCloseButton]="true" [(visible)]="popupNota">

    <div class="warning-popup">
        <i class="dx-icon-warning warning-icon"></i>

        <div class="warning-text">
            <h3>Nota di restituzione</h3>

            <dx-text-area class="nota-textarea" [(value)]="nota" autoResizeEnabled="false"
                [inputAttr]="{ 'aria-label': 'Notes' }">
            </dx-text-area>
        </div>

        <div class="warning-actions">
            <dx-button text="Conferma Nota" type="default" stylingMode="contained" class="dx-button-orange"
                (onClick)="onPopupOk()">
            </dx-button>
        </div>
    </div>
</dx-popup>
}

@if(popupSceltaMatricola){
<dx-popup [width]="600" [height]="250" [showTitle]="true" title="" [dragEnabled]="false" [hideOnOutsideClick]="true"
    [(visible)]="popupSceltaMatricola">
    <app-popup-scelta-matricola [listMatricole]="listMatricoleDisponibiliFiltrate"
        (idMatricolaEventEmitter)="onIdMatricolaEventEmitter($event)"></app-popup-scelta-matricola>
</dx-popup>
}